// A contact is a "duplicate" if another contact in the same database shares its ig link or
// tt link — used to flag potential dupes in red across the Database page and the mailer
// "add from database" pickers. Names are intentionally NOT compared.
export const computeDuplicateIds = (contacts) => {
  const groups = {};
  const addTo = (key, id) => { if (!key) return; (groups[key] = groups[key] || []).push(id); };
  contacts.forEach((c) => {
    addTo(c.ig_link && `ig:${c.ig_link.trim().toLowerCase()}`, c.id);
    addTo(c.tt_link && `tt:${c.tt_link.trim().toLowerCase()}`, c.id);
  });
  const dupes = new Set();
  Object.values(groups).forEach((ids) => { if (ids.length > 1) ids.forEach((id) => dupes.add(id)); });
  return dupes;
};
